// export const BaseURL = "http://localhost:8000";
// export const BaseURL = 'https://hellohealthtest.foxiomlabs.com'
export const BaseURL = "https://server.hello-health.us";
